import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ScrollView, View } from 'react-native';
import { Typography } from '../../../typography';
import { BLACK_300, WHITE } from '../../../../constants';
import { StateConfigContext } from '../../../../providers';
import { Card } from '../../../card';
import { getChartProps, getChartStyles } from '../../ChartStyles';
import { Legend } from '../../components/legend/Legend';
var ChartWrapper = _ref => {
  var type = _ref.type,
    children = _ref.children,
    style = _ref.style;
  return type == 'doughnut' ? _jsx(View, Object.assign({
    style: style
  }, {
    children: children
  })) : _jsx(ScrollView, Object.assign({
    horizontal: true
  }, {
    children: children
  }));
};
var LegendComponent = props => {
  var type = props.type,
    _props$hideLegend = props.hideLegend,
    hideLegend = _props$hideLegend === void 0 ? false : _props$hideLegend,
    _props$legendPosition = props.legendPosition,
    legendPosition = _props$legendPosition === void 0 ? type == 'doughnut' ? 'right' : 'top' : _props$legendPosition,
    _props$showCustomLege = props.showCustomLegend,
    showCustomLegend = _props$showCustomLege === void 0 ? false : _props$showCustomLege,
    renderCustomLegend = props.renderCustomLegend,
    data = props.data;
  var labels = data === null || data === void 0 ? void 0 : data.labels;
  return _jsx(_Fragment, {
    children: showCustomLegend ? renderCustomLegend === null || renderCustomLegend === void 0 ? void 0 : renderCustomLegend({
      data,
      labels
    }) : _jsx(_Fragment, {
      children: !hideLegend && _jsx(Legend, Object.assign({}, props, {
        legendPosition: legendPosition
      }))
    })
  });
};
export var ChartRenderer = props => {
  var stateContext = useContext(StateConfigContext);
  var _props = getChartProps(props, stateContext);
  var chartStyles = getChartStyles(_props);
  var _props$type = props.type,
    type = _props$type === void 0 ? 'line' : _props$type,
    _props$withCard = props.withCard,
    withCard = _props$withCard === void 0 ? false : _props$withCard,
    chartComponent = props.chartComponent,
    doughnutCenterText = props.doughnutCenterText,
    cardProps = props.cardProps,
    style = props.style;
  var doughnutType = type === 'doughnut';
  var jsx = _jsx(_Fragment, {
    children: _jsxs(ChartWrapper, Object.assign({
      type: type,
      style: chartStyles.container
    }, {
      children: [_jsxs(View, Object.assign({
        style: chartStyles.wrapperStyle
      }, {
        children: [chartComponent, doughnutType && !!doughnutCenterText && _jsx(View, Object.assign({
          style: chartStyles.centerTextStyle
        }, {
          children: _jsx(Typography, {
            multiText: doughnutCenterText,
            textAlignment: "center"
          })
        })), !doughnutType && _jsx(LegendComponent, Object.assign({}, props))]
      })), doughnutType && _jsx(LegendComponent, Object.assign({}, props))]
    }))
  });
  if (withCard) {
    return _jsx(Card, Object.assign({
      backgroundColor: WHITE,
      borderColor: BLACK_300,
      paddingToken: 'SPACING_32',
      style: style
    }, cardProps, {
      children: jsx
    }));
  }
  return _jsx(_Fragment, {
    children: jsx
  });
};